export const webcamDeviceIDs = {
  materialCameraPG: "3dee0daed88b4ff478a4c981a6a53f711a254cd66bdcffaaa071eb129cede350",
  scaleCameraPG: "8a400e3ee5fe28759bfbb2645d828d47186482f3c1a9e9a57391797e6234f9cb",
  materialCameraBW: "683ed0fe0e9830bccf0bcd6276719a3dba712a58f62fdb47fc8f1a35939ada27",
  scaleCameraBW: "1a31aef180be74bf345d1e526661e&27137c8e634cc328350a5f0244f2658d24",
};
